import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BsPlayCircle } from 'react-icons/bs';

interface CandidatoBancaResponse {
    candidatoId: string;
    nome: string;
    nomeSocial: string;
}

interface VideoViewModalProps {
    show: boolean;
    onHide: () => void;
    selectedCandidato: CandidatoBancaResponse | null;
    videoUrl: string | null;
}

const VideoViewModal: React.FC<VideoViewModalProps> = ({
    show,
    onHide,
    selectedCandidato,
    videoUrl
}) => {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton className="bg-success text-white">
                <Modal.Title>
                    <BsPlayCircle className="me-2" />
                    Vídeo de {selectedCandidato?.nomeSocial || selectedCandidato?.nome}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center p-0">
                {videoUrl && (
                    <video controls width="100%" className="rounded-bottom">
                        <source src={videoUrl} type="video/mp4" />
                        Seu navegador não suporta o elemento de vídeo.
                    </video>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default VideoViewModal;
